module.exports = __webpack_public_path__ + "img/CapMan_logo_grey_rgb_2018-01.c2d364a3.png";